module.exports = __webpack_public_path__ + "img/electric_enabled_selected.5bd270e2.svg";